import { Button, Flex, Stack, Text } from '@chakra-ui/react'
import { Link as RouterLink, Navigate, useNavigate, useParams } from 'react-router-dom'
import { LuArrowLeft } from 'react-icons/lu'
import EventLegacy from '../components/legacy/EventLegacy'
import { useAuth } from '../contexts/AuthContext'
import { useTranslation } from '../i18n'

/**
 * `/events/:eventId/classic` — the event page as it was before the workspace,
 * kept as a fallback. Reached only from the workspace sidebar; the workspace
 * is the default everywhere. See the header of EventLegacy.jsx.
 */
export default function ClassicEventPage() {
  const { eventId } = useParams()
  const navigate = useNavigate()
  const { isModeratorOnly } = useAuth()
  const { t } = useTranslation()

  // Moderators get no settings view — not even read-only, and not via a pasted URL.
  if (isModeratorOnly(eventId)) {
    return <Navigate to={`/events/${eventId}/moderation`} replace />
  }

  return (
    <Stack gap={4}>
      <Flex
        role="note"
        align="center"
        gap={3}
        wrap="wrap"
        px={4}
        py={3}
        borderRadius="md"
        bg="var(--mc-info-bg)"
      >
        <Text flex="1" minW="240px" fontSize="sm">{t('workspace.classicNotice')}</Text>
        <Button asChild size="xs" variant="outline">
          <RouterLink to={`/events/${eventId}`}>{t('workspace.classicBack')}</RouterLink>
        </Button>
      </Flex>
      <Button size="sm" variant="outline" onClick={() => navigate('/events')} alignSelf="flex-start">
        <LuArrowLeft /> {t('workspace.allEvents')}
      </Button>
      <EventLegacy eventId={eventId} creatingEvent={false} onCreated={null} defaultOpen={true} />
    </Stack>
  )
}
